import { render, staticRenderFns } from "./superwordCarving.vue?vue&type=template&id=6e64e54c&scoped=true"
import script from "./superwordCarving.vue?vue&type=script&lang=js"
export * from "./superwordCarving.vue?vue&type=script&lang=js"
import style0 from "./superwordCarving.vue?vue&type=style&index=0&id=6e64e54c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e64e54c",
  null
  
)

export default component.exports